// The backend stores money as paise (integers). These helpers convert for display and input.
const inr = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
const inrShort = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 2 });

/** 125050 -> "₹1,250.50" */
export const money = (paise?: number | null) => inr.format((paise || 0) / 100);
/** 125000 -> "₹1,250" (drops .00) */
export const moneyShort = (paise?: number | null) => inrShort.format((paise || 0) / 100);

/** "1250.5" -> 125050, "" -> null */
export function toPaise(value: string | number | null | undefined): number | null {
  if (value === '' || value === null || value === undefined) return null;
  const n = Number(value);
  return Number.isFinite(n) ? Math.round(n * 100) : null;
}
